import { SecondaryButton } from '../Button';
import useSlackUninstall from './useSlackUninstall';
import useBroadcastChannel from '../../utils/hooks/useBroadcastChannel';
import { noop } from 'lodash';
import { MaybeNil } from '../../utils/interfaces';

export const UninstallSlackButton = () => {
  const { slackUninstall, slackUninstallLoading } = useSlackUninstall();

  const { broadcast } = useBroadcastChannel<MaybeNil<string>>({
    channelName: 'slack',
    messageHandler: noop,
  });

  const handleClick = async () => {
    const message = await slackUninstall();
    broadcast(message);
  };

  return (
    <SecondaryButton
      onClick={handleClick}
      isOutlined
      disabled={slackUninstallLoading}
      trackContext="slack"
      trackAction="uninstall"
    >
      Disconnect from Slack
    </SecondaryButton>
  );
};
